module.exports = __webpack_public_path__ + "img/azr.915087b1.svg";